import { cn } from "../../../lib/utils";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { useScheduleStore } from "../../../stores/schedule-store";
import { dispatchScheduleEvent, endHistoryMerge } from "../../../lib/schedule-history/dispatch";

export function ArtCreditLine() {
  const handle = useScheduleStore(state => state.profile.artist_handle);
  return <ArtCreditInput handle={handle}
    onChange={value => dispatchScheduleEvent({ type: "profile/set", patch: { artist_handle: value } }, "profile:artist_handle")} onBlur={endHistoryMerge} className="border-0 px-0 py-0" />;
}

type ArtCreditInputProps = { handle: string; onChange: (value: string) => void; onBlur?: () => void; className?: string; };

export function ArtCreditInput({ handle, onChange, onBlur, className }: ArtCreditInputProps) {
  const { t } = useTranslation();
  const id = useId();

  return (
    <div className={cn("flex items-baseline gap-3 border-t border-neutral-200 bg-white px-4 py-3", className)}>
      <label htmlFor={id} className="shrink-0 text-xs font-semibold uppercase tracking-wider text-neutral-500">{t("art.creditPrefix")}</label>
      <input id={id} value={handle} placeholder="@creator" spellCheck={false} aria-label={t("art.creatorHandle")}
        className="h-9 min-w-0 flex-1 border-b-2 border-neutral-300 bg-transparent text-base font-medium outline-none placeholder:font-normal placeholder:text-neutral-400 focus:border-neutral-900"
        onBlur={onBlur}
        onChange={event => onChange(event.target.value)} />
    </div>
  );
}
